import { Button } from 'components/ui/button';
import React, { useState } from 'react';

const VoiceSelectionSkeleton = () => {
  const [tab, setTab] = useState<'Female' | 'Male'>('Female');
  return (
    <div className="w-full max-w-[850px] rounded-md h-auto md:h-[410px]">
      <div className="flex flex-col md:flex-row">
        {/* Voices Selection */}
        <div className="flex flex-col gap-4 justify-center p-4 sm:pl-10 bg-background-main sm:w-[650px] rounded-t-md sm:rounded-l-md">
          {/* Tab Selection for Mobile */}
          <div className="md:hidden flex justify-around">
            <button
              className={`text-[16px] ${tab === 'Female' ? 'font-bold border-b-2 border-[#846CEC]' : 'text-gray-500 border-b-2 border-transparent'}`}
              onClick={() => setTab('Female')}
            >
              Female
            </button>
            <button
              className={`text-[16px] ${tab === 'Male' ? 'font-bold border-b-2 border-[#846CEC]' : 'text-gray-500 border-b-2 border-transparent'}`}
              onClick={() => setTab('Male')}
            >
              Male
            </button>
          </div>

          <div className="grid grid-flow-col md:grid-cols-2 gap-x-10">
            {/* Female Voices */}
            {(tab === 'Female' || window.innerWidth >= 768) && (
              <div className="w-full">
                <h1 className="text-text-secondary hidden sm:flex uppercase text-[16px] font-normal">
                  Female
                </h1>
                <div className="grid grid-rows-4 gap-4 mt-0 sm:mt-4">
                  {Array(4)
                    .fill(1)
                    .map((idx) => {
                      return (
                        <div
                          key={idx}
                          className="w-full h-12 bg-gray-300 animate-pulse rounded-md"
                        />
                      );
                    })}
                </div>
              </div>
            )}
            {/* Male Voices */}
            {(tab === 'Male' || window.innerWidth >= 768) && (
              <div className="w-full">
                <h1 className="text-text-secondary uppercase text-[16px] font-normal hidden sm:flex">
                  Male
                </h1>
                <div className="grid grid-rows-4 gap-4 mt-0 sm:mt-4">
                  {Array(4)
                    .fill(1)
                    .map((idx) => {
                      return (
                        <div
                          key={idx}
                          className="w-full h-12 bg-gray-300 animate-pulse rounded-md"
                        />
                      );
                    })}
                </div>
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="pt-1 flex w-full gap-4 justify-end">
            <Button
              variant="customSecondary"
              type="button"
              className="text-[14px]"
              size="sm"
            >
              Cancel
            </Button>
            <Button
              variant="customPrimary"
              disabled
              type="button"
              className="text-[14px] disabled:bg-background-main disabled:text-text-secondary"
            >
              Confirm
            </Button>
          </div>
        </div>
        {/* Image Section */}
        <div className="bg-background-card w-full md:w-[270px] rounded-br-md md:rounded-r-md flex flex-col items-center justify-center gap-4 p-4 py-12">
          <p className="text-left font-bold text-lg md:text-2xl">
            Celebrity voices coming soon. Stay tuned!
          </p>
          <div className="w-32 h-28 hidden md:block md:w-52 md:h-40 bg-white rounded-md">
            <img
              src="/podcast-voice-image.png"
              alt="podcast"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceSelectionSkeleton;
